export default __webpack_public_path__ + "static/media/menu-accountWhite.ec1a7468.svg";